import type { MailboxInfo } from 'owa-client-types';
import { prefetchNaaRequestForMailboxInfo } from 'owa-nested-app-auth';
import { MsalNestedAppAuthExecutor } from './MsalNestedAppAuthExecutor';
import type { NestedAppAuthPrefetchRequest } from 'owa-nested-app-auth-types';

export default function prefetchMsalNestedAppAuthRequest(
    mailboxInfo: MailboxInfo,
    request: NestedAppAuthPrefetchRequest,
    host: string,
    scenarioName: string
): void {
    return prefetchNaaRequestForMailboxInfo(
        MsalNestedAppAuthExecutor,
        mailboxInfo,
        request,
        host,
        scenarioName
    );
}
